import { Component, OnInit } from '@angular/core';
import { DashboardWrapperComponent } from '../../components/dashboard-wrapper/dashboard-wrapper.component';
import { LoaderComponent } from 'app/components/loader/loader.component';
import { TranslateModule } from '@ngx-translate/core';
import { NotificationsService } from './notifications.service';
import { DashboardService } from '../../dashboard.service';
import { CommonModule } from '@angular/common';
import { CommonService } from 'app/services/common.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-notifications',
    standalone: true,
    imports: [
        DashboardWrapperComponent,
        LoaderComponent,
        TranslateModule,
        CommonModule,
    ],
    templateUrl: './notifications.component.html',
    styleUrl: './notifications.component.scss',
})
export class NotificationsComponent implements OnInit {
    notifications: any = [];
    isLoading: boolean = false;
    constructor(
        private ntService: NotificationsService,
        private _dashboardService: DashboardService,
        private _commonService: CommonService,
        private _router: Router
    ) {}

    selectedLanguage: any;

    ngOnInit(): void {
        this._dashboardService.language$.subscribe((lang) => {
            this.selectedLanguage = lang;
        });
        this.fetchNotifications();
    }

    fetchNotifications() {
        this.isLoading = true;
        this.ntService.getNotifications().subscribe({
            next: (data) => {
                if (data?.notifications) {
                    this.notifications = data?.notifications;

                    this.isLoading = false;
                }
            },
            error: (err) => {
                console.log(err);
                this.isLoading = false;
            },
        });
    }

    handleNotification(item = null) {
        if (!item) return this.readNotification(-1);

        this.readNotification(item?.notificationId);
        const caseData = item?.newData
            ? JSON.parse(item?.newData)
            : JSON.parse(item?.oldData);
        this._router.navigate(['/applications'], {
            queryParams: {
                appId: caseData?.id,
            },
        });
    }

    readNotification(id) {
        this.ntService.readNotification(id).subscribe({
            next: (data) => {
                this.fetchNotifications();
                this._commonService.triggerRefresh();
            },
            error: (err) => {
                console.log(err);
            },
        });
    }
}
